import React, { ReactNode } from 'react';
import { OverviewDetailInterface } from 'components/Overview/overview.types';
import { Grid, Typography } from '@mui/material';
import RichText from 'components/RichText/RichText';

interface OverviewDetailProps extends Omit<OverviewDetailInterface, 'value'> {
  value?: ReactNode;
  children?: ReactNode;
}

type Props = OverviewDetailProps;

const OverviewDetail = ({ title, value, richText, xs, sm, md, lg, xl, hide, children }: Props) => {
  if ((!value && children == null) || hide) {
    return null;
  }

  return (
    <Grid
      item
      xs={xs ?? 12}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      py={2}
      key={`${(typeof value).toString()}-${title}`}
    >
      <Typography
        variant='subtitle1'
        component='div'
        sx={{ fontWeight: 500, fontSize: '1.125rem', color: 'black' }}
      >
        {title}
      </Typography>
      {richText ? <RichText value={`${value}`} /> : value}
      {children}
    </Grid>
  );
};

export default OverviewDetail;
